var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 63,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zero State"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -152,
    y: -377,
    width: 360,
    height: 800,
    rx: 10,
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 514",
    opacity: 0.06,
    cx: 28.5,
    cy: 31.5,
    r: 79.5,
    fill: "#DEE1FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973353418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1818 6.09375H16.6364C14.3391 6.09375 12.1455 7.0092 10.5218 8.61557C8.89818 10.2392 8 12.4328 8 14.7301V49.2756C8 51.5728 8.91545 53.7665 10.5218 55.3901C12.1455 57.0137 14.3391 57.9119 16.6364 57.9119H37.3636C39.6609 57.9119 41.8545 56.9965 43.4782 55.3901C45.1018 53.7665 46 51.5728 46 49.2756V21.6392H37.3636C34.4964 21.6392 32.1818 19.3247 32.1818 16.4574V6.09375Z",
    fill: "#2E406F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 450",
    d: "M4 2L56 58",
    stroke: "#0F1E45",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 451",
    d: "M2 5L54 61",
    stroke: "#2E406F",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.364 51.2749H25.6367C26.5867 51.2749 27.364 50.4976 27.364 49.5476C27.364 48.5976 26.5867 47.8203 25.6367 47.8203H14.364C13.414 47.8203 12.6367 48.5976 12.6367 49.5476C12.6367 50.4976 13.414 51.2749 14.364 51.2749Z",
    fill: "#0E204A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.364 43.642H22.7276C23.6776 43.642 24.4549 42.8648 24.4549 41.9148C24.4549 40.9648 23.6776 40.1875 22.7276 40.1875H14.364C13.414 40.1875 12.6367 40.9648 12.6367 41.9148C12.6367 42.8648 13.414 43.642 14.364 43.642Z",
    fill: "#0E204A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.364 36.4545H19.7276C20.6776 36.4545 21.4549 35.6773 21.4549 34.7273C21.4549 33.7773 20.6776 33 19.7276 33H14.364C13.414 33 12.6367 33.7773 12.6367 34.7273C12.6367 35.6773 13.414 36.4545 14.364 36.4545Z",
    fill: "#0E204A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6367 9.27605V16.4615C35.6367 17.4115 36.414 18.1888 37.364 18.1888H43.3922C44.0485 18.1888 44.4113 17.4115 43.9794 16.9106L37.0013 8.75787C36.5349 8.22241 35.6367 8.5506 35.6367 9.25878V9.27605Z",
    fill: "#2E406F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoScheduleIcon);
export default __webpack_public_path__ + "static/media/noScheduleIcon.3e1fd179eb93510949ca05f59d665866.svg";
export { ForwardRef as ReactComponent };